import { useEffect, useState, type RefObject } from 'react';

// Watch the container ref's width and return a scale factor that fits the
// `logicalWidth` inside it, capped at 1 (we never enlarge above design size).
// Used by both the world-map canvas and the in-modal skill canvas so a single
// logical layout adapts to any viewport.
export function useFitScale(
  ref: RefObject<HTMLElement>,
  logicalWidth: number,
  padding = 24,
): number {
  const [width, setWidth] = useState<number | null>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const ro = new ResizeObserver(entries => setWidth(entries[0].contentRect.width));
    ro.observe(el);
    return () => ro.disconnect();
  }, [ref]);
  if (width === null) return 1;
  return Math.min(1, (width - padding) / logicalWidth);
}
